import React from 'react'
import * as S from './styled'
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import PinterestIcon from '@mui/icons-material/Pinterest';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { FlexContainer } from '../../styles/common/FlexBox';
import {institucionalLinks} from '../../constants/Footer/institucional';
import {helpLinks} from '../../constants/Footer/helpLinks';
import { mainLinks } from '../../constants/Footer/mainLinks';
import { specialDatesLeft } from '../../constants/Footer/specialDatesLeft';
import { specialDatesRight } from '../../constants/Footer/specialdatesRight';

const Footer = ({bgColor}) => {
  const iconStyle = { fontSize: "30px" };
  
  return (
    <S.Body bgColor={bgColor}>
        <FlexContainer justify="center" align="flex-start" gap="35px" padding="15px 0"  mobileAlign="center" wrap="wrap">
          <S.LinksWrapper style={{ minWidth: 150 }}>
            <div>
              <p style={{ margin: "0 0 10px 0" }}>
                Institucional
              </p>
            </div>
            <FlexContainer direction="column" align="flex-start" gap="2px">
              {institucionalLinks.map(({ href, label }) => (
                <a key={href} href={href}>
                  {label}
                </a>
              ))}
            </FlexContainer>
          </S.LinksWrapper>
          <S.LinksWrapper style={{ minWidth: 150 }}>
            <div>
              <p style={{ margin: "0 0 10px 0" }}>Links</p>
            </div>
            <FlexContainer direction="column" align="flex-start" gap="2px">
              {mainLinks.map(({ href, label }) => (
                <a key={href} href={href}>
                  {label}
                </a>
              ))}
            </FlexContainer>
          </S.LinksWrapper>
          <S.LinksWrapper style={{ minWidth: 150 }}>
            <div>
              <p style={{ margin: "0 0 10px 0" }}>Ajuda</p>
            </div>
            <FlexContainer direction="column" align="flex-start" gap="2px">
              {helpLinks.map(({ href, label }) => (
                  <a key={href} href={href}>
                    {label}
                  </a>
                ))}
            </FlexContainer>
          </S.LinksWrapper>
          <S.LinksWrapper style={{ minWidth: 150 }}>
            <p style={{ margin: "0 0 10px 0" }}>
              Datas Especiais
            </p>
            <FlexContainer justify="center" align="flex-start">
              <FlexContainer direction="column" align="flex-start" gap="2px" style={{ minWidth: 150 }}>
              {specialDatesLeft.map(({ href, label }) => (
                  <a key={href} href={href}>
                    {label}
                  </a>
                ))}
              </FlexContainer>
              <FlexContainer direction="column" align="flex-start" gap="2px" style={{ minWidth: 150 }}>
                {specialDatesRight.map(({ href, label }) => (
                    <a key={href} href={href}>
                      {label}
                    </a>
                  ))}
              </FlexContainer>
            </FlexContainer>
          </S.LinksWrapper>
          <div>
            <p style={{ margin: "0 0 10px 0" }}>
              Acompanhe nossas redes sociais:
            </p>
            <FlexContainer justify="center" gap="8px" align="center" wrap="wrap"  mobileDirection="row">
              <a 
              href="https://www.facebook.com/MeuCupomOficial"
              target="_blank"
              rel="noopener noreferrer"
              >
                <FacebookIcon sx={iconStyle}/>
              </a>
              <a 
              href="https://x.com/MeuCupomOficial"
              target="_blank"
              rel="noopener noreferrer"
              >
                <XIcon sx={iconStyle}/>
              </a>
              <a 
              href="https://www.instagram.com/meucupom/"
              target="_blank"
              rel="noopener noreferrer"
              >
                <InstagramIcon sx={iconStyle}/> 
              </a>
              <a 
              href="https://br.pinterest.com/meucupom/"
              target="_blank"
              rel="noopener noreferrer"
              >
                <PinterestIcon sx={iconStyle}/>
              </a>
              <a href="https://www.youtube.com/channel/UCnfaULjn-bxe0HTig3akg9g"
              target="_blank"
              rel="noopener noreferrer"
              >
                <YouTubeIcon sx={iconStyle}/>
              </a>
              <a href="https://www.linkedin.com/company/meucupom-com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <LinkedInIcon sx={iconStyle}/>  
              </a>
            </FlexContainer>
          </div>
        </FlexContainer>
        <FlexContainer
        gap={100}
        mobileGap={40}
        justify="center"
        align="center"
        padding="15px"
        style={{borderTop: 'solid white 1px'}}
        >
          <img src="https://cdn.meucupom.com/app-assets/5.05.87/novomc/assets/images/logo-negative.png" alt="" />
          <div>
            <S.FooterText> 
              Todos os descontos são oferecidos por terceiros, cujas condições de compra, riscos, preço e demais informações devem ser obtidas diretamente junto ao anunciante.
            </S.FooterText>
            <S.FooterText>
              PW BRANDS SERVIÇOS DE MIDIA LTDA | CNPJ: 19.994.038/0001-55 | Inscrição Municipal: 0.609.191-1
            </S.FooterText>
            <S.FooterText>
              Endereço: Praia do Flamengo 66, Grupo 1213, Bloco B | Atendimento ao cliente: contato@meucupom.com
            </S.FooterText>
            <S.FooterText>
              © 2014-2024 | meucupom.com and the tag symbol are registered trademarks of PW BRANDS S M LTDA, inc. All Rights Reserved.
            </S.FooterText>
              
          </div>
        </FlexContainer>
    </S.Body>
  )
}

export default Footer